import Helmet from './components/Helmet/Helmet';

export default Helmet;
